import React from 'react';
import { Link } from '@grnhse/seedling/lib/birch/typography';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import styled from 'styled-components';
import { RediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';

type Props = {
  application: RediscoveryApplication;
};

const CandidateName = styled(Link)`
  color: ${FullPalette.GRAY_1000};
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  display: block;
  padding: 12px 0;

  &:hover {
    text-decoration: underline;
  }
`;

const RediscoveryCandidateCell = ({ application }: Props) => {
  return (
    <CandidateName
      href={application.candidateProfilePath}
      className="candidate-full-name pii-blur"
      target="_blank"
      rel="noopener noreferrer"
    >
      {application.fullName}
    </CandidateName>
  );
};

export default RediscoveryCandidateCell;
